import { SetStateAction } from "react";
import { AnswerSetResult } from "../../../store/viewmodels/AnswerSetViewModel";
import { getDate, getClockTime } from "../../utils/DateServices";

export interface ResultItemProps {
    answerSet: AnswerSetResult,
    setSelectedAnswerset: React.Dispatch<SetStateAction<AnswerSetResult>>,
}

export function ResultItem(props: ResultItemProps): JSX.Element {

    function buttonClick() {
        props.setSelectedAnswerset(props.answerSet);
    }

    const timeParse = Date.parse(props.answerSet.end_time);
    const time = new Date(timeParse);
    const date = getDate(time);
    const clockTime = getClockTime(time);

    return (
        <div className="my-1 mx-2" key={"answersetResult" + props.answerSet.itemset.name + props.answerSet.end_time} >
            <button className="w-80 text-left border border-transparent rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500" onClick={buttonClick}>
                <div className="pt-1 ml-4 text-md font-medium">{props.answerSet.itemset.name}</div>
                <div className="pb-1 ml-4 text-sm">{date + " " + clockTime}</div>
            </button>
        </div>
    );
}